import React from 'react';
import IconButton from '../../icon-button';
import withPopover from '../hoc/with-popover';

const RedoButton = (props) => <IconButton {...props} glyph="redo" />;

export default withPopover(RedoButton);
